/**
 * Model to hold a mapping between ranking points and an event
 */
export class IdentityRankingPointsEvent {
    public id: string = null;
    public rankingPointsId: string = null;
    public eventId: string = null;

    public clone(): IdentityRankingPointsEvent {
        const clone: IdentityRankingPointsEvent = new IdentityRankingPointsEvent();
        clone.id = this.id;
        clone.rankingPointsId = this.rankingPointsId;
        clone.eventId = this.eventId;

        return clone;
    }

    public serialize(): any {
        const json: any = {
            data: {
                type: 'rankingPointsEvent',
                id: this.id,
                attributes: {
                    eventId: this.eventId,
                },
            },
        };

        return JSON.stringify(json);
    }

    public deserialize(json: any): IdentityRankingPointsEvent {
        json = json || {};
        const attrs: any = json.attributes || {};

        this.id = json.id;
        this.rankingPointsId = attrs.rankingPointsId;
        this.eventId = attrs.eventId;

        return this;
    }
}
